import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressCarousel from '../components/ProgressCarousel';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleShadowKissedPlatform = () => {
    navigate('/admin/analyze');
  };

  const handleBibaChatAI = () => {
    const workflowId = 'wf_69601c3be8588190945d0661d7bc9a780ea0cce45c44f95f';
    navigate(`/admin/chat-ai?workflow=${workflowId}`);
  };

  const handleShadowRandomGenerator = () => {
    navigate('/random-generator');
  };

  return (
    <div className="landing-page">
      <div className="landing-container">
        <h1>Welcome to ShadowKissed</h1>
        <ProgressCarousel />
        <div className="landing-links">
          <button 
            className="landing-link shadowkissed-platform" 
            onClick={handleShadowKissedPlatform}
          >
            ShadowKissedPlatform
          </button>
          <button 
            className="landing-link biba-chat-ai" 
            onClick={handleBibaChatAI}
          >
            Biba Chat
          </button>
          <button 
            className="landing-link shadow-random-generator" 
            onClick={handleShadowRandomGenerator}
          >
            ShadowRandomGenerator
          </button>
        </div>
      </div>
    </div>
  );
};

export default Landing;

